import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';

import { UpsellBullets } from '@edx/frontend-plugin-advertisements';

import messages from './messages';

const UpgradeBenefits = ({ isFBE }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="mt-3.5">
      <hr />
      <span className="lead text-primary-500">
        {formatMessage(messages.upgradeBenefitsSectionTitle)}
      </span>
      <div className="ml-n4 mt-n3">
        <UpsellBullets {...{ isFBE }} />
      </div>
    </div>
  );
};

UpgradeBenefits.propTypes = {
  isFBE: PropTypes.bool.isRequired,
};

export default UpgradeBenefits;
